import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

//**Este es el boton para cerrar los modales */
const ModalCloseIcon = ({ onClick }) =>{
    return(
        <IconButton
            aria-label="close"
            onClick={onClick}
            sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: "#000000DE"

            }}
        >
            <CloseIcon />
        </IconButton>
    )
}

export default ModalCloseIcon

